module.exports = ($el) ->
  return unless $el.length
